// => Import React
import React, { useState } from "react";

//=> Import plugins
import { useStaticQuery, graphql, Link } from "gatsby";
import { MdKeyboardArrowDown } from 'react-icons/md'
//=> Import styles
import {
  filterBar,
  select,
  categoriesTitle,
  categoriesList,
  categorieItem,
  categorieIcon,
  filterContainer,
} from "./styles.module.scss";


//=> Component

const FilterBar = ({ setProducts }) => {

  const [hideListCategories, setHideListCategories] = useState(false);
  // => Trie les produits au onChangeSelect
  const onChangeSelect = (e) => {
    if (setProducts) setProducts(e.target.value);
  };

  const onclickButtonCategorie = () => {
    setHideListCategories(!hideListCategories);
  };

  const hanlderOnkeyDown = (e) => {
    if (e.keyCode === 13) {
      setHideListCategories(!hideListCategories);
    }
  }

  // => Liste categorie
  const data = useStaticQuery(graphql`
    query {
      allStrapiCategorie {
        edges {
          node {
            name
            slug
          }
        }
      }
    }
  `);

  const categories = data.allStrapiCategorie.edges.map(
    (categorie) => categorie
  );

  return (
    <div className={filterContainer}>
      <div className={filterBar}>
        <select className={select} onChange={onChangeSelect} title="Trier les produits">
          <option value="" defaultValue>
            Trier les produits
          </option>
          <option value="alphabetiqueAZ">Ordre alphabétique[A-Z]</option>
          <option value="alphabetiqueZA">Ordre alphabétique[Z-A]</option>
          <option value="croissant">Prix croissant</option>
          <option value="decroissant">Prix decrroissant</option>
        </select>


        <div className={categoriesTitle} onClick={onclickButtonCategorie} title="Categorie" role="listitem" tabIndex="0" onKeyDown={hanlderOnkeyDown}>
          Categories <MdKeyboardArrowDown size="1.2em" className={categorieIcon} />
        </div>

      </div>
      {hideListCategories && (
        <div className={categoriesList}>
          {categories.map((categorie) => (
            <Link
              to={`/categorie/${categorie.node.slug}#title`}
              key={categorie.node.slug}
              className={categorieItem}
              title={`${categorie.node.name}`}
            >
              <strong>{categorie.node.name}</strong>
            </Link>
          ))}
        </div>
      )}
    </div>

  );
};

export default FilterBar;
